export default {
  message(vm, {
    group = 'frontend', title = 'Title', text = 'Message', icon = null, iconSize = 'lg', spin = false,
  } = {}, type = '') {
    vm.$notify({
      type,
      group,
      title,
      text,
      data: {
        icon, iconSize, spin,
      },
    });
  },
  success(vm, {
    group = 'frontend', title = 'Completed', text = false, icon = 'check-circle', iconSize = 'lg',
  } = {}, type = 'success') {
    vm.$notify({
      type,
      group,
      title,
      text,
      data: {
        icon, iconSize,
      },
    });
  },
  loading(vm, {
    group = 'frontend', title = 'Sending Request', text = 'Take a breath', icon = 'circle-notch', iconSize = 'lg', spin = true, duration = 10000,
  } = {}, type = '') {
    vm.$notify({
      type,
      group,
      title,
      text,
      duration,
      data: {
        icon, iconSize, spin,
      },
    });
  },
  clean(vm, group = 'frontend', timeout = 500) {
    return new Promise((resolve) => {
      setTimeout(() => {
        vm.$notify({ group, clean: true });
      }, timeout);
      setTimeout(() => {
        resolve();
      }, timeout * 1.8);
    });
  },
  errors(vm, errors) {
    const errorsData = errors.response.data;
    if (typeof errorsData.errors !== 'undefined' && !_.isEmpty(errorsData.errors)) {
      _.each(errorsData.errors, async (val) => {
        this.message(vm, { title: val[0], text: false, icon: 'times-circle' }, 'danger');
      });
    } else if (typeof errorsData.exception !== 'undefined' && !_.isEmpty(errorsData.exception)) {
      this.message(vm, { title: errorsData.exception, text: false, icon: 'times-circle' }, 'danger');
    } else if (typeof errorsData.message !== 'undefined' && !_.isEmpty(errorsData.message)) {
      this.message(vm, { title: errorsData.message, text: false, icon: 'times-circle' }, 'danger');
    }
  },
};
